export default class ReplacementActionDto {
    constructor(obj) {
        this.piezometerId = obj.piezometerId
        this.date = obj.date
        this.hour = obj.hour
        this.action = obj.action
        this.materielId = obj.materielId
    }
}